var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88.052,
    height: 49.508,
    viewBox: "0 0 88.052 49.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7297",
    "data-name": "Rettangolo 7297",
    width: 88.052,
    height: 49.508,
    transform: "translate(0 0)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36175",
    "data-name": "Tracciato 36175",
    d: "M2.342,1.808a.651.651,0,0,0-.652.649v8.819a.663.663,0,0,0,.163.433c.011.01.852-.94,1.248-1.043l.007-7.687H85.1s.983-1,1.019-1.032a.622.622,0,0,0-.406-.139Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.02,
    y1: 4.813,
    x2: -0.008,
    y2: 4.813,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.251,
    stopColor: "#e1081f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#e01f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631,
    stopColor: "#df4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#dd786a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc967e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36176",
    "data-name": "Tracciato 36176",
    d: "M2.426,36.944c-.406.062-.736.3-.736.665v8.818a.674.674,0,0,0,.165.432,6.112,6.112,0,0,1,1.236-1.02l.017-7.71,40.905-6.516L85.1,38.129s.96-.973,1-1.007a1.179,1.179,0,0,0-.464-.176l-41.614-6.5Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.02,
    y1: 1.161,
    x2: -0.008,
    y2: 1.161,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#e2001a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#e1081f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#e01f2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#df4447"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    stopColor: "#dd786a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc967e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9042",
    "data-name": "Raggruppa 9042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36172",
    "data-name": "Tracciato 36172",
    d: "M.221.221V49.25l43.924-6.98,43.688,6.835V.221Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36173",
    "data-name": "Tracciato 36173",
    d: "M.439.441H87.612V48.849l-43.6-6.8L.439,48.992ZM0,0V49.508l44.013-7.015L87.8,49.325l.252.039V0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9035",
    "data-name": "Raggruppa 9035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9034",
    "data-name": "Raggruppa 9034",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rettangolo_7296",
    "data-name": "Rettangolo 7296",
    d: "M.651,0H84.023a.649.649,0,0,1,.649.649V9.47a.651.651,0,0,1-.651.651H.651A.651.651,0,0,1,0,9.47V.651A.651.651,0,0,1,.651,0Z",
    transform: "translate(1.69 1.806)",
    fill: "#e2001a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36174",
    "data-name": "Tracciato 36174",
    d: "M86.362,46.427a.65.65,0,0,1-.651.649l-41.7-6.515L2.339,47.076a.65.65,0,0,1-.649-.649V37.608c0-.36.328-.6.736-.665l41.587-6.5s35.756,5.587,41.613,6.506c.478.1.736.316.736.662Z",
    fill: "#e2001a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9037",
    "data-name": "Raggruppa 9037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9036",
    "data-name": "Raggruppa 9036",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7298",
    "data-name": "Rettangolo 7298",
    width: 84.427,
    height: 9.911,
    transform: "translate(1.69 1.808)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9039",
    "data-name": "Raggruppa 9039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9038",
    "data-name": "Raggruppa 9038",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_7299",
    "data-name": "Rettangolo 7299",
    width: 84.401,
    height: 16.418,
    transform: "translate(1.69 30.441)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9041",
    "data-name": "Raggruppa 9041"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_9040",
    "data-name": "Raggruppa 9040",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36177",
    "data-name": "Tracciato 36177",
    d: "M84.442,10.647A.66.66,0,0,0,85.1,10V2.979S86.068,2,86.116,1.946a.656.656,0,0,1,.247.511v8.819a.65.65,0,0,1-.652.649H2.341a.648.648,0,0,1-.487-.217c.483-.483,1.018-1.061,1.364-1.061Z",
    fill: "#aa140a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36178",
    "data-name": "Tracciato 36178",
    d: "M44.012,39.281,84.441,45.8a.659.659,0,0,0,.656-.65l0-7.018s.968-.979,1-1.005a.492.492,0,0,1,.269.484v8.819a.65.65,0,0,1-.651.649l-41.7-6.515L2.342,47.076a.648.648,0,0,1-.487-.217A4.226,4.226,0,0,1,3.216,45.8Z",
    fill: "#aa140a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36179",
    "data-name": "Tracciato 36179",
    d: "M10.249,23.8c-.059,1.331-.774,1.995-1.689,1.995A1.243,1.243,0,0,1,7.3,24.611c0-.861.465-1.131,1.362-1.376a6.225,6.225,0,0,0,1.589-.617Zm3.867-3.544c0-2.46.042-5-5.007-5-2.5,0-5.314.592-5.437,4.185H7.42c.019-.542.264-1.305,1.507-1.305a1.175,1.175,0,0,1,1.322,1.182c0,.812-.55,1.01-1.1,1.132-2.056.469-5.967.322-5.967,4.36a3.5,3.5,0,0,0,3.729,3.861,3.893,3.893,0,0,0,3.4-1.527h.042a4.125,4.125,0,0,0,.14,1.206h4.116a6.056,6.056,0,0,1-.491-2.853Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36180",
    "data-name": "Tracciato 36180",
    d: "M16.348,28.351H20.38V23.305c0-2.731.856-3.863,2.445-3.863a3.444,3.444,0,0,1,1.587.32V15.453a3.984,3.984,0,0,0-1.182-.2c-1.466,0-2.32.84-2.971,2.364h-.044V15.576H16.348Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36181",
    "data-name": "Tracciato 36181",
    d: "M28.833,20.526c.183-1.378.875-2.142,2.077-2.142a1.945,1.945,0,0,1,1.772,2.142Zm7.718,2.536c0-4.975-1.813-7.805-6.009-7.805-3.338,0-5.576,3.026-5.576,6.746,0,4.257,2.545,6.669,5.922,6.669a5.424,5.424,0,0,0,5.438-4.037H32.559a1.9,1.9,0,0,1-1.69.912c-1.262,0-1.955-1.034-2.054-2.485Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36182",
    "data-name": "Tracciato 36182",
    d: "M36.651,28.351H41.07l1.485-3.125,1.55,3.125h4.439L44.8,21.633l3.318-6.057H43.8l-1.182,2.536-1.161-2.536H37.019l3.318,6.057Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36183",
    "data-name": "Tracciato 36183",
    d: "M60.135,21.953c0-3.543-1.787-6.7-5.759-6.7s-5.761,3.153-5.761,6.7,1.79,6.719,5.761,6.719,5.759-3.173,5.759-6.719m-4.027,0c0,1.353-.207,3.176-1.732,3.176s-1.733-1.823-1.733-3.176.208-3.148,1.733-3.148,1.732,1.8,1.732,3.148",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36184",
    "data-name": "Tracciato 36184",
    d: "M61.687,28.351h4.028V21.607c0-2.042.918-2.46,1.611-2.46,1.178,0,1.323,1.031,1.323,2.51v6.694h4.034V19.589c0-2.93-1.732-4.333-3.629-4.333A3.669,3.669,0,0,0,65.618,17.2h-.044V15.576H61.687Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36185",
    "data-name": "Tracciato 36185",
    d: "M84.45,19.3c-.1-3.273-2.852-4.038-5.13-4.038-2.116,0-4.987.84-4.987,4.063,0,2.19,1.242,3.372,4.313,4.012,1.873.4,2.224.616,2.224,1.353s-.837.983-1.367.983a1.463,1.463,0,0,1-1.079-.367,1.675,1.675,0,0,1-.487-1.132h-3.85c.062,3.3,2.79,4.5,5.273,4.5,2.566,0,5.376-.96,5.376-4.5A3.528,3.528,0,0,0,82.21,20.6c-1.34-.543-2.87-.643-3.539-.984a.745.745,0,0,1-.469-.667c0-.837.652-.985,1.22-.985a1.261,1.261,0,0,1,.9.369,1.288,1.288,0,0,1,.465.961Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36186",
    "data-name": "Tracciato 36186",
    d: "M82.827,13.746a1.3,1.3,0,1,0,1.305-1.288,1.294,1.294,0,0,0-1.305,1.288m.236,0a1.067,1.067,0,1,1,1.069,1.113,1.067,1.067,0,0,1-1.069-1.113m.564.762h.236v-.65h.249l.411.65h.255l-.434-.669a.388.388,0,0,0,.4-.41c0-.292-.171-.433-.532-.433h-.585Zm.236-1.323h.312c.159,0,.333.031.333.233,0,.238-.19.25-.4.25h-.245Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36187",
    "data-name": "Tracciato 36187",
    d: "M3.422,38l18.236-2.92-.357.2L4.088,38.492a.671.671,0,0,0-.6.71l-.365,4.829-.309.563L2.8,38.719A.7.7,0,0,1,3.422,38",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36188",
    "data-name": "Tracciato 36188",
    d: "M2.969,9.843l.16-.478.7-5.176a.539.539,0,0,1,.536-.537l19-.682.266-.177H3.505a.536.536,0,0,0-.536.537Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.71dadc922b6ce558a21fa01141cf519d.svg";
export { ForwardRef as ReactComponent };